<template>
  <div class="">
    <!-- header section start  -->
    <section class="text-center">
      <p class="mb-0 font-extrabold text-base md:text-xl" style="color:#8A94A6">Pricing</p>
      <h2 class="text-black font-black tracking-wide text-2xl md:text-4xl">
        Plans to help you grow your business
      </h2>
    </section>
    <!-- header section end   -->
    <!-- pricing table  -->
    <section class="mt-10">
      <!-- toggle section  -->
      <div class="wrapperToggle">
        <div
          :class="[
            'taeb-switch text-center',
            activeTab === 'yearly' ? 'left' : 'right',
          ]"
        >
          <div
            :class="['taeb whitespace-no-wrap', activeTab === 'yearly' ? 'activeTab' : '']"
            taeb-direction="left"
            @click="activeTab = 'yearly'"
          >
           Yearly (save up to 20%)
          </div>
          <div
            :class="['taeb-monthly', activeTab === 'monthly' ? 'activeTab' : '']"
            taeb-direction="right"
            @click="activeTab = 'monthly'"
          >
            Monthly
          </div>
        </div>
      </div>
      <!-- toggle section  -->
      <section class="flex flex-wrap justify-center mt-10 md:mt-16 md:justify-between md:px-20 lg:px-10">
        <div
          class="mt-5 xl:mt-0"
          v-for="(cardData, index) in pricingTable"
          :key="index + cardData.title"
        >
          <pricing-card :cardData="cardData" :activeTab="activeTab" :index="index" />
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import PricingCard from './PricingCard.vue';

export default {
  components: { PricingCard },
  name: 'HomePricingTable',
  layout: 'null',
  data() {
    return {
      activeTab: 'yearly',
      pricingTable: [
        {
          title: 'Free',
          description: 'For figuring out Twitter',
          monthly: '0',
          yearly: '0',
          onFocus: false,
          keyPoints: [
            {
              title: 'Reply & DMing Dashboard',
            },
            // {
            //   title: '1 basic pipeline',
            // },
            // {
            //   title: 'Queried lists',
            // },
            // {
            //   title: 'List based replies & DMing',
            // },
            {
              title: '10 broadcast DM per day',
            },
            {
              title: '300 Managed contacts',
            },
          ],
        },
        {
          title: 'Creator',
          description: 'For prioritizing relationships',
          monthly: '15',
          yearly: '9',
          onFocus: false,
          keyPoints: [
            {
              title: 'Basic Pipelines',
            },
            // {
            //   title: '3 pipelines',
            // },
            // {
            //   title: '1-click dynamic segments',
            // },
            // {
            //   title: 'Notes & Reminders',
            // },
            {
              title: '125 broadcast DM per day',
            },
            {
              title: '1000 Managed contacts',
            },
          ],
        },
        {
          title: 'Pro',
          description: 'For systematizing relationships',
          monthly: '29',
          yearly: '24',
          onFocus: true,
          keyPoints: [
            {
              title: 'Unlimited pipelines',
            },
            // {
            //   title: 'Sequences (coming soon)',
            // },
            // {
            //   title: 'DM Templates & Exporting (coming soon)',
            // },
            {
              title: '250 broadcast DM per day',
            },
            {
              title: '3000 Managed contacts',
            },
          ],
        },
        {
          title: 'Business',
          description: 'For scaling your business',
          monthly: '49',
          yearly: '39',
          onFocus: false,
          keyPoints: [
            {
              title: 'Auto-updating segments',
            },
            // {
            //   title: 'Pipeline Reminders (coming soon)',
            // },
            // {
            //   title: 'Pipeline Templates (coming soon)',
            // },
            {
              title: '500 broadcast DM per day',
            },
            {
              title: '5,000 Managed contacts',
            },
          ],
        },
      ],
    };
  },
};
</script>

<style>
/* taeb-switch styles */
.taeb-switch {
  position: relative;
  display: flex;
  justify-content: space-between;
}

.taeb-switch:after {
  content: '';
  position: absolute;
  top: 0;
  transition: all cubic-bezier(0.88, 0.35, 0.565, 1.35) 0.4s;
  border-radius: 27.5px;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.1);
  background-color: #07225b;
  height: 100%;
  z-index: 0;
}

.taeb-switch.left:after {
  left: 0;
  width: 70%;
}

.taeb-switch.right:after {
  left: 70%;
  width: 30%;
}
.taeb-switch .taeb  {
  width: 70%;
}

.taeb-switch .taeb, .taeb-switch .taeb-monthly  {
  padding: 12px 0;
  z-index: 1;
  position: relative;
  cursor: pointer;
  transition: color 200ms;
  font-size: 16px;
  font-weight: bold;
  line-height: normal;
  user-select: none;
}
.taeb-monthly {
  width: 30%;
  padding: 12px 0;
  z-index: 1;
  position: relative;
  cursor: pointer;
  transition: color 200ms ease-in-out;
  font-size: 16px;
  font-weight: bold;
  line-height: normal;
  user-select: none;
}

.taeb-switch .taeb.activeTab, .taeb-monthly.activeTab {
  color: #ffffff;
}

.wrapperToggle {
  max-width: 400px;
  border-radius: 37px;
  background-color: #f4f4f4;
  padding: 8px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
}

@media (max-width: 600px) {
  .wrapperToggle {
    max-width: 200px;
    padding: 5px;
  }
  .taeb-switch .taeb, .taeb-switch .taeb-monthly {
    padding: 5px 0;
    font-size: 10px;
  }
}
</style>
